import { useEffect, useState } from 'react';
import { BrowserRouter, Routes, Route, Navigate, useLocation } from 'react-router-dom';

import LoginPage from './pages/LoginPage';
import AdminLayout from './layouts/AdminLayout';

import RecibosPage from './pages/RecibosPage';
import HistoricoPage from './pages/HistoricoPage';
import DetalleReciboPage from './pages/DetalleReciboPage';
import ConfiguracionPage from './pages/ConfiguracionPage';
import EmpresasPage from './pages/EmpresasPage';
import PersonasPage from './pages/PersonasPage';
import CatalogosPage from './pages/CatalogosPage';
import DashboardPage from './pages/DashboardPage';
import CajaPage from './pages/CajaPage';
import CajaChicaPage from './pages/CajaChicaPage';
import { obtenerMisCajasChicas } from './services/cajaChicaService';
import { obtenerTokenSesion, obtenerUsuarioSesion } from './utils/sesion';

function obtenerRolUsuario(usuario) {
  return usuario.Rol || usuario.rol || '';
}

function esRolAdministrativo(usuario) {
  const rol = obtenerRolUsuario(usuario);
  return rol === 'Administrador' || rol === 'Operador';
}

function esRolCajaChica(usuario) {
  return obtenerRolUsuario(usuario) === 'CajaChica';
}

function RutaProtegida() {
  const token = obtenerTokenSesion();
  const location = useLocation();
  const [estadoAcceso, setEstadoAcceso] = useState({ cargando: true, soloCajaChica: false });

  useEffect(() => {
    let cancelado = false;

    async function resolverAcceso() {
      if (!token) return;

      const usuario = obtenerUsuarioSesion();

      if (esRolAdministrativo(usuario)) {
        if (!cancelado) setEstadoAcceso({ cargando: false, soloCajaChica: false });
        return;
      }

      if (esRolCajaChica(usuario)) {
        if (!cancelado) setEstadoAcceso({ cargando: false, soloCajaChica: true });
        return;
      }

      try {
        await obtenerMisCajasChicas();
        if (!cancelado) setEstadoAcceso({ cargando: false, soloCajaChica: true });
      } catch {
        if (!cancelado) setEstadoAcceso({ cargando: false, soloCajaChica: true });
      }
    }

    resolverAcceso();

    return () => {
      cancelado = true;
    };
  }, [token]);

  if (!token) {
    return <Navigate to="/login" replace />;
  }

  if (estadoAcceso.cargando) {
    return <div className="p-4 text-muted">Validando acceso...</div>;
  }

  if (estadoAcceso.soloCajaChica && location.pathname !== '/caja-chica') {
    return <Navigate to="/caja-chica" replace />;
  }

  return <AdminLayout soloCajaChica={estadoAcceso.soloCajaChica} />;
}

function App() {
  return (
    <BrowserRouter>
      <Routes>

        <Route
          path="/login"
          element={<LoginPage />}
        />

        <Route
          path="/"
          element={<RutaProtegida />}
        >
          <Route
            index
            element={<DashboardPage />}
          />

          <Route
            path="dashboard"
            element={<DashboardPage />}
          />

          <Route
            path="recibos"
            element={<RecibosPage />}
          />

          <Route
            path="historico"
            element={<HistoricoPage />}
          />

          <Route
            path="caja"
            element={<CajaPage />}
          />

          <Route
            path="caja-chica"
            element={<CajaChicaPage />}
          />

          <Route
            path="recibos/:id"
            element={<DetalleReciboPage />}
          />

          <Route
            path="configuracion"
            element={<ConfiguracionPage />}
          />

          <Route
            path="empresas"
            element={<EmpresasPage />}
          />

          <Route
            path="personas"
            element={<PersonasPage />}
          />

          <Route
            path="catalogos"
            element={<CatalogosPage />}
          />
        </Route>

        <Route
          path="*"
          element={
            <Navigate
              to={obtenerTokenSesion() ? '/dashboard' : '/login'}
              replace
            />
          }
        />

      </Routes>
    </BrowserRouter>
  );
}

export default App;
